import { ReactComponent as FilterSliderThick } from 'assets/icons/icon-filter-slider-thick.svg';

export default FilterSliderThick;
